var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"mt-0 pt-0 pb-0",attrs:{"items":_vm.$t('view.sales_force.reflect.data_labels.opportunity.free_period'),"persistent-hint":true,"value":_vm.value,"autocomplete":"off"},on:{"input":_vm.handleInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02bbda7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/FreePeriod.vue
// module id = MBta
// module chunks = 1